import {each} from "lodash"

export default class EventEmitter {
  addListener(type, fn) {
    this.__listeners = this.__listeners || {}
    this.__listeners[type] = this.__listeners[type] || []
    this.__listeners[type].push(fn)
  }
  removeListener(type, fn) {
    if (this.__listeners && this.__listeners[type]) {
      let index = this.__listeners[type].indexOf(fn)
      if (index >= 0)
        this.__listeners[type].splice(index, 1)
    }
  }
  emit(type, ...args) {
    if (this.__listeners && this.__listeners[type]) {
      each(this.__listeners[type], fn => { if (fn) { fn(...args) } });
    }
  }
}
